(function () {
  const ROOT_SELECTOR = '[data-led-pdp-section]';
  const STICKY_NAV_SELECTOR = '.led-pdp__anchors';
  let stickyUpdateFrame = 0;

  const VARIANT_SWATCHES = [
    { pattern: /(?:bianco )?caldo|2200\s*k|2500\s*k|2700\s*k|3000\s*k/, color: '#f3c64f' },
    { pattern: /(?:bianco )?naturale|neutr|4000\s*k/, color: '#fff0cf' },
    { pattern: /(?:bianco )?freddo|5000\s*k|6000\s*k|6500\s*k/, color: '#b9e3fb' },
    { pattern: /rosso/, color: '#dc3b37' },
    { pattern: /verde/, color: '#35a853' },
    { pattern: /blu/, color: '#3d78d8' },
    { pattern: /nero/, color: '#242a30' },
    { pattern: /bianco/, color: '#f6f6f4' },
    { pattern: /rgb|multicolore/, color: 'conic-gradient(#dc3b37, #f3c64f, #35a853, #3d78d8, #dc3b37)' },
  ];

  function isVisible(element) {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && Number(style.opacity || 1) > 0
      && rect.width > 0
      && rect.height > 0;
  }

  function getVisibleHeaderBottom() {
    const headerGroup = document.querySelector('#header-group');
    if (!headerGroup) return 0;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const maximumOffset = Math.min(320, viewportHeight * 0.45);
    const groupRect = headerGroup.getBoundingClientRect();
    let visibleBottom = isVisible(headerGroup) && groupRect.top <= 0 && groupRect.bottom > 0
      ? groupRect.bottom
      : 0;

    const candidates = headerGroup.querySelectorAll(
      'header-component, .header-section, .header__row, [class*="sticky-header"]'
    );

    candidates.forEach((candidate) => {
      if (!isVisible(candidate)) return;

      const style = window.getComputedStyle(candidate);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;

      const rect = candidate.getBoundingClientRect();
      if (rect.top <= 1 && rect.bottom > 0) visibleBottom = Math.max(visibleBottom, rect.bottom);
    });

    return Math.max(0, Math.min(maximumOffset, Math.round(visibleBottom)));
  }

  function updateStickyTabs(root) {
    const nav = root.querySelector(STICKY_NAV_SELECTOR);
    if (!nav) return;

    const stickyTop = getVisibleHeaderBottom();
    root.style.setProperty('--led-pdp-sticky-top', `${stickyTop}px`);

    const navRect = nav.getBoundingClientRect();
    root.style.setProperty('--led-pdp-anchor-height', `${Math.ceil(navRect.height)}px`);
    nav.dataset.ledStuck = String(navRect.top <= stickyTop + 1);
  }

  function updateAllStickyTabs() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(updateStickyTabs);
  }

  function scheduleStickyTabsUpdate() {
    if (stickyUpdateFrame) return;

    stickyUpdateFrame = window.requestAnimationFrame(() => {
      stickyUpdateFrame = 0;
      updateAllStickyTabs();
    });
  }

  function moveIntoSlot(root, selector, slotName) {
    const source = root.querySelector(`.product-details ${selector}`);
    const target = root.querySelector(`[data-led-slot-content="${slotName}"]`);

    if (!source || !target || target.contains(source)) return false;

    target.appendChild(source);
    const panel = target.closest('[data-led-panel]');
    if (panel) panel.hidden = false;
    return true;
  }

  function placePurchaseContent(root) {
    const details = root.querySelector('.product-details .group-block-content');
    if (!details) return;

    const title = details.querySelector('h1');
    const titleBlock = title ? title.closest('.text-block') : null;
    const meta = root.querySelector('[data-led-product-meta]');
    if (meta && titleBlock && !details.contains(meta)) {
      titleBlock.before(meta);
      meta.hidden = false;
    }

    const price = details.querySelector('product-price');
    const klarnaMessage = root.querySelector('[data-led-klarna-message]');
    if (price && klarnaMessage) {
      if (price.nextElementSibling !== klarnaMessage) price.after(klarnaMessage);
      klarnaMessage.hidden = false;
    }

    const buyButtons = details.querySelector('.buy-buttons-block');
    const purchaseNote = root.querySelector('[data-led-purchase-note]');
    const buttonGrid = buyButtons && buyButtons.querySelector('.product-form-buttons');
    const acceleratedCheckout = buttonGrid && buttonGrid.querySelector('.accelerated-checkout-block');
    if (purchaseNote && buyButtons && !buyButtons.contains(purchaseNote)) {
      if (buttonGrid) {
        if (acceleratedCheckout) {
          acceleratedCheckout.before(purchaseNote);
        } else {
          buttonGrid.appendChild(purchaseNote);
        }
      } else {
        buyButtons.after(purchaseNote);
      }
      purchaseNote.hidden = false;
    }

    const services = root.querySelector('.led-pdp__services');
    if (services && buyButtons && !details.contains(services)) {
      const servicesWrap = services.closest('.led-pdp__services-wrap');
      buyButtons.after(services);
      if (servicesWrap) servicesWrap.remove();
    }
  }

  function normalizeOptionValue(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function getVariantSwatch(value) {
    const normalizedValue = normalizeOptionValue(value);
    const swatch = VARIANT_SWATCHES.find((entry) => entry.pattern.test(normalizedValue));
    return swatch ? swatch.color : '';
  }

  function enhanceVariantCards(root) {
    root.querySelectorAll('.variant-option__button-label').forEach((label) => {
      const input = label.querySelector('input');
      if (!input) return;

      let status = label.querySelector('[data-led-variant-status]');
      if (!status) {
        status = document.createElement('span');
        status.className = 'led-pdp__variant-status';
        status.dataset.ledVariantStatus = '';
        label.appendChild(status);
      }

      const available = input.dataset.optionAvailable !== 'false';
      status.dataset.available = String(available);
      status.textContent = available
        ? 'Disponibile · preparazione 0–1 giorno'
        : 'Non disponibile';

      const color = getVariantSwatch(input.value);
      let swatch = label.querySelector('[data-led-variant-swatch]');
      if (color && !swatch) {
        swatch = document.createElement('span');
        swatch.className = 'led-pdp__variant-swatch';
        swatch.dataset.ledVariantSwatch = '';
        swatch.setAttribute('aria-hidden', 'true');
        label.appendChild(swatch);
      }

      if (swatch) {
        if (color) {
          swatch.style.setProperty('--led-variant-swatch', color);
          swatch.hidden = false;
        } else {
          swatch.hidden = true;
        }
      }

      label.dataset.ledHasSwatch = String(Boolean(color));
      label.dataset.ledVariantCard = 'true';
    });
  }

  function getRomeDate() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Rome',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));

    return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
  }

  function isBusinessDay(date) {
    const day = date.getUTCDay();
    return day !== 0 && day !== 6;
  }

  function nextBusinessDayOnOrAfter(date) {
    const result = new Date(date);
    while (!isBusinessDay(result)) result.setUTCDate(result.getUTCDate() + 1);
    return result;
  }

  function addBusinessDays(date, days) {
    const result = new Date(date);
    let remaining = days;
    while (remaining > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (isBusinessDay(result)) remaining -= 1;
    }
    return result;
  }

  function formatDeliveryDate(date, includeYear) {
    return new Intl.DateTimeFormat('it-IT', {
      timeZone: 'UTC',
      weekday: 'short',
      day: 'numeric',
      month: 'long',
      ...(includeYear ? { year: 'numeric' } : {}),
    }).format(date).replace(/\./g, '');
  }

  function updateDeliveryEstimate(root, available) {
    const availability = root.querySelector('[data-led-availability]');
    const availabilityText = root.querySelector('[data-led-availability-text]');
    const deliveryRange = root.querySelector('[data-led-delivery-range]');
    if (!availability || !availabilityText || !deliveryRange) return;

    availability.dataset.available = String(available);
    availabilityText.textContent = available ? 'Disponibile.' : 'Variante non disponibile.';
    deliveryRange.hidden = !available;
    if (!available) {
      deliveryRange.textContent = '';
      return;
    }

    const preparationStart = nextBusinessDayOnOrAfter(getRomeDate());
    const earliestDelivery = addBusinessDays(preparationStart, 1);
    const latestDelivery = addBusinessDays(preparationStart, 4);
    deliveryRange.textContent = ` Consegna stimata tra ${formatDeliveryDate(earliestDelivery, false)} e ${formatDeliveryDate(latestDelivery, true)}.`;
  }

  function placeDetailContent(root) {
    moveIntoSlot(root, '.shopify-app-block', 'specifications');
    placeAccordionRows(root);
  }

  function placeAccordionRows(root) {
    const source = root.querySelector('.product-details .accordion')
      || root.querySelector('[data-led-slot-content="shipping"] > .accordion');
    if (!source) return;

    const rows = Array.from(source.querySelectorAll('accordion-custom'));
    if (!rows.length) {
      moveIntoSlot(root, '.accordion', 'shipping');
      return;
    }

    rows.forEach((row) => {
      const heading = (row.querySelector('summary')?.textContent || row.textContent || '').trim();
      const slotName = /tecnic|specific/i.test(heading) ? 'specifications' : 'shipping';
      const target = root.querySelector(`[data-led-slot-content="${slotName}"]`);
      if (!target) return;

      let group = target.querySelector(`[data-led-accordion-group="${slotName}"]`);
      if (!group) {
        group = document.createElement('div');
        group.className = source.className;
        group.dataset.ledAccordionGroup = slotName;
        group.setAttribute('style', source.getAttribute('style') || '');
        target.appendChild(group);
      }

      group.appendChild(row);
      const panel = target.closest('[data-led-panel]');
      if (panel) panel.hidden = false;
    });

    const shippingTarget = root.querySelector('[data-led-slot-content="shipping"]');
    if (shippingTarget && source.textContent.trim()) {
      shippingTarget.appendChild(source);
      const shippingPanel = shippingTarget.closest('[data-led-panel]');
      if (shippingPanel) shippingPanel.hidden = false;
    } else {
      source.remove();
    }
  }

  function updateVariantMeta(root, variant) {
    if (!variant) return;

    const skuWrap = root.querySelector('[data-led-sku-wrap]');
    const sku = root.querySelector('[data-led-sku]');
    if (skuWrap && sku) {
      const value = variant.sku || '';
      sku.textContent = value;
      skuWrap.hidden = value.length === 0;
    }

    updateDeliveryEstimate(root, Boolean(variant.available));
    window.requestAnimationFrame(() => enhanceVariantCards(root));
  }

  function init(root) {
    placePurchaseContent(root);
    placeDetailContent(root);
    enhanceVariantCards(root);
    const availability = root.querySelector('[data-led-availability]');
    updateDeliveryEstimate(root, !availability || availability.dataset.available !== 'false');
    updateStickyTabs(root);

    if (root.dataset.ledPdpBound === 'true') return;
    root.dataset.ledPdpBound = 'true';
    root.addEventListener('variant:update', (event) => {
      updateVariantMeta(root, event.detail && event.detail.resource);
    });
  }

  function hydrate(scope) {
    const roots = scope.matches && scope.matches(ROOT_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll(ROOT_SELECTOR));
    roots.forEach(init);
  }

  function start() {
    hydrate(document);
    scheduleStickyTabsUpdate();
    [250, 800, 1800].forEach((delay) => {
      window.setTimeout(() => {
        hydrate(document);
        scheduleStickyTabsUpdate();
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('scroll', scheduleStickyTabsUpdate, { passive: true });
  window.addEventListener('resize', scheduleStickyTabsUpdate);
  document.addEventListener('shopify:section:load', (event) => {
    hydrate(event.target);
    scheduleStickyTabsUpdate();
  });
  document.addEventListener('transitionend', (event) => {
    if (event.target instanceof Element && event.target.closest('#header-group')) {
      scheduleStickyTabsUpdate();
    }
  }, true);

  const headerGroup = document.querySelector('#header-group');
  if (headerGroup && 'ResizeObserver' in window) {
    new ResizeObserver(scheduleStickyTabsUpdate).observe(headerGroup);
  }
})();
